module.exports = {
  designsteins2019: {
    pagename: 'designsteins2019',
    name: 'Designsteins.com',
    description:
      'Design company website developed using php, jQuery and HTML5/CSS3. Designed by the company and developed by myself.',
    livelink: 'https://designsteins.com',
    github: null,
    img: 'thumb-designsteins-2019.png',
    fullimg: 'website-designsteins-2019.png'
  },
  iamsogal: {
    pagename: 'iamsogal',
    name: 'IAmSoGal.com',
    description:
      'A flexible WordPress based website for a venture capital firm investing in early stage startups. Developed using php, jQuery and HTML5/CSS3 with 15 custom widgets.',
    livelink: 'https://iamsogal.com',
    github: null,
    img: 'thumb-sogal.png',
    fullimg: 'website-sogal.png'
  },
  tuvototuidioma: {
    pagename: 'tuvototuidioma',
    name: 'TuVotoTuIdioma',
    description:
      'A WordPress based website to promote awareness of early voting and Spanish language ballots for Spanish speaking citizens of Florida. Developed using php, jQuery and HTML5/CSS3.',
    livelink: 'https://tuvototuidioma.com',
    github: null,
    img: 'thumb-tuvototuidioma.png',
    fullimg: 'website-tuvototuidioma.png'
  },
  earlycollegevote: {
    pagename: 'earlycollegevote',
    name: 'EarlyCollegeVote.com',
    description:
      "A WordPress based website to promote awareness of early voting locations and procedures for college aged voters in Florida. Developed using php, jQuery and HTML5/CSS3 and built as a multisite for language toggling between English and Spanish. Additionally, I customized a version of Participants Database for their email collections based on client's specifications.",
    livelink: 'https://earlycollegevote.com',
    github: null,
    img: 'thumb-earlycollegevote.png',
    fullimg: 'website-earlycollegevote.png'
  },
  togetherwevote: {
    pagename: 'togetherwevote',
    name: 'Together We Vote',
    description:
      'A WordPress based website to inform voters regarding Wisconsin voting laws for the 2018 Wisconsin election. Developed using php, jQuery and HTML5/CSS3 and built as a multisite for language toggling between English, Spanish and Hmong.',
    livelink: 'https://togetherwevote.org',
    github: null,
    img: 'thumb-togetherwevote.png',
    fullimg: 'website-togetherwevote.jpg'
  }
};
